export default __webpack_public_path__ + "static/media/customer.4aed6899.png";